/* Onboarding workflow constants — shared by pages. */

export const STATUS_LABELS = {
  draft: "Draft",
  submitted: "Submitted",
  under_medical_review: "Under Medical Review",
  readmit_pending: "Readmission Pending Approval",
  information_requested: "Information Requested",
  medical_approved: "Medical Approved",
  under_operational_assessment: "Under Operational Assessment",
  operationally_approved: "Operationally Approved",
  assigned: "Assigned",
  visit_in_progress: "Visit In Progress",
  visit_completed: "Visit Completed",
  rejected: "Rejected",
};

export const STATUS_COLORS = {
  draft: { color: "#94A3B8", bg: "#94A3B814" },
  submitted: { color: "#06B6D4", bg: "#06B6D414" },
  under_medical_review: { color: "#6366F1", bg: "#6366F114" },
  readmit_pending: { color: "#D97706", bg: "#D9770614" },
  information_requested: { color: "#F59E0B", bg: "#F59E0B14" },
  medical_approved: { color: "#0B7E8C", bg: "#0B7E8C14" },
  under_operational_assessment: { color: "#6366F1", bg: "#6366F114" },
  operationally_approved: { color: "#10B981", bg: "#10B98114" },
  assigned: { color: "#0B7E8C", bg: "#0B7E8C14" },
  visit_in_progress: { color: "#6366F1", bg: "#6366F114" },
  visit_completed: { color: "#10B981", bg: "#10B98114" },
  rejected: { color: "#EF4444", bg: "#EF444414" },
};

export const HOSPITAL_COORDINATOR_ROLES = ["hospital_coordinator", "admin"];
export const HAH_PHYSICIAN_ROLES = ["hah_physician", "physician", "admin"];
export const HAH_COORDINATOR_ROLES = ["hah_coordinator", "care_coordinator", "admin"];
export const HOME_CARE_TEAM_ROLES = ["home_care_team", "admin"];

export function canCreateRequest(role) { return HOSPITAL_COORDINATOR_ROLES.includes(role); }
export function canMedicalReview(role) { return HAH_PHYSICIAN_ROLES.includes(role); }
export function canOperationalReview(role) { return HAH_COORDINATOR_ROLES.includes(role); }
export function canAssignTeam(role) { return HAH_COORDINATOR_ROLES.includes(role); }
export function canConductVisit(role) { return HOME_CARE_TEAM_ROLES.includes(role); }
